import { render } from "./TabNav.vue?vue&type=template&id=1d0c9de0&scoped=true"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"

import "./TabNav.vue?vue&type=style&index=0&id=1d0c9de0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0c9de0"]])

export default __exports__